<template>
	<div>
		<div  class="head row email-add-row">
			<h3  class="pl-3 email-ad-h3">Emailadressen</h3>
			<div style="width:50%" class="adr-btnWrap">
                <router-link to="emailaddresses/create" class="btn btn-dark btn-sm mr-3 email-ad-a" style="float: right;margin-bottom: 15px;">Nieuw Emailadres</router-link>
            </div>
		</div>
		<div class="mail-in-wrap">
			<table class="table table-responsive table-hover">
				<thead>
					<tr>
					<th></th>
					<th>Emailadressen</th>
					<th>Commissies</th>
					<th>Gebruikers</th>
					</tr>
				</thead>
				<thead>
					<tr>
					<th></th>
					<th><input type="text" v-model="search.emailaddress" placeholder="Zoeken..." class="form-control"></th>
					<th><input type="text" v-model="search.committee" placeholder="Zoeken..." class="form-control"></th>
					<th><input type="text" v-model="search.user" placeholder="Zoeken..." class="form-control"></th>
					</tr>
				</thead>
				<thead></thead>
				<tbody>
					<tr v-for="(email_row,index) in emailaddressFilterList" :key="index">
					<td>
						<div class="btn-group">
							<a :href="'/settings/emailaddresses/'+email_row.id" class="btn btn-primary"><i class="fas fa-pencil-alt"></i></a>
							<a @click="deletetemp(email_row.id)" class="btn btn-danger"><i class="fa fa-trash"></i></a>
						</div>
					</td>
					<td>{{email_row.emailaddress}}</td>
					<td>
						<ul>
							<li v-for="(com, indc) in email_row.committees" :key="'email_com_' + indc">
								{{ com.title }}
							</li>
						</ul>
					</td>
					<td>
						<ul>
							<li v-for="(com, indc) in email_row.users" :key="'email_com_' + indc">
								{{ com.display_name }}
							</li>
						</ul>
					</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	name: 'index',
	components: {},
	data () {
		return {
			mailtemplates:[],
			emailaddresses:[],
			filteremailaddress:[],
			search :{}
		}
	},
	computed: {
		emailaddressFilterList(){
			if(this.search['emailaddress'] || this.search['committee'] || this.search['user']){
				console.log('searching....');
				return this.emailaddresses.filter((item)=>{

					if(this.search['emailaddress']){
						if(item.emailaddress){
							if(typeof item.emailaddress != "undefined"){
								return this.search['emailaddress'].toLowerCase().split(' ').every(v => item.emailaddress.toLowerCase().includes(v))
							}
						}
					}

					if(this.search['committee']){
						if(item.committees){
							return item.committees.some(com => com.title.toLowerCase().includes(this.search['committee'].toLowerCase()))
						}
					}

					if(this.search['user']){
						if(item.users){
							return item.users.some(us => us.display_name.toLowerCase().includes(this.search['user'].toLowerCase()))
						}
					}

				})
			}else{
				return this.emailaddresses;
			}
		},
    },
	methods:{
		
		getEmailAddress(){
           this.$store.dispatch('get','/api/v1/emailaddress')
			.then(data=>{
				console.log(data.data);
				this.emailaddresses=data.data.data;
			})
			.catch(error=>{
				console.log(error.request);
			});
		},

		filter(){
			/*
			this.$store.dispatch('post',{
					details:{search:this.search},
					endpoint:'/api/v1/emailaddress/filter'
				})
				.then(data=>{
					console.log(data.data);
					this.emailaddresses = data.data.data;
				})
				.catch(error=>{
					console.log(error.request);
				}); */ 
		},

		deletetemp(id){
			this.$store.dispatch('get','/api/v1/delete-emailaddress/'+id).then((data)=>{
				console.log(data);
			})
			.catch(error=>{
				console.log(error);
			});

			this.emailaddresses = this.emailaddresses.filter((d)=> d.id != id);
		}
	},
	mounted: function(){
		console.log('mounted');
		this.getEmailAddress();
	}
}
</script>

<style lang="css" scoped>
</style>
